export const setDice = (value) => ({ type: 'SET_DICE', value });
export const showDice = (value) => ({ type: 'SHOW_DICE', value });

export const setHighestBet = (value) => ({ type: 'SET_HIGHEST_BET', value });

export const resetHighestBet = (value) => ({ type: 'RESET_HIGHEST_BET' });
